import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormBody = _resolveComponent("FormBody")!
  const _component_FormEdge = _resolveComponent("FormEdge")!
  const _component_FormThread = _resolveComponent("FormThread")!
  const _component_FormInside = _resolveComponent("FormInside")!
  const _component_FormPocket = _resolveComponent("FormPocket")!
  const _component_FormSide = _resolveComponent("FormSide")!
  const _component_FormFront = _resolveComponent("FormFront")!
  const _component_FormTack = _resolveComponent("FormTack")!
  const _component_FormBack = _resolveComponent("FormBack")!
  const _component_FormName = _resolveComponent("FormName")!
  const _component_FormNameMobile = _resolveComponent("FormNameMobile")!
  const _component_FormBagsize = _resolveComponent("FormBagsize")!
  const _component_FormBagsizeMobile = _resolveComponent("FormBagsizeMobile")!
  const _component_GreenboardTab = _resolveComponent("GreenboardTab")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormBody, { index: 0 }),
    _createVNode(_component_FormEdge, { index: 1 }),
    _createVNode(_component_FormThread, { index: 2 }),
    _createVNode(_component_FormInside, { index: 3 }),
    _createVNode(_component_FormPocket, { index: 4 }),
    _createVNode(_component_FormSide, { index: 5 }),
    _createVNode(_component_FormFront, { index: 6 }),
    _createVNode(_component_FormTack, { index: 7 }),
    _createVNode(_component_FormBack, { index: 8 }),
    _createVNode(_component_FormName, {
      index: 9,
      class: "hide-mobile"
    }),
    _createVNode(_component_FormNameMobile, {
      index: 9,
      class: "hide-desktop"
    }),
    _createVNode(_component_FormBagsize, {
      index: 10,
      class: "hide-mobile"
    }),
    _createVNode(_component_FormBagsizeMobile, {
      index: 10,
      class: "hide-desktop"
    }),
    _createVNode(_component_GreenboardTab, { index: 11 })
  ]))
}